import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { post } from "../../utils/helpers/http";
import { getLocalStorageData } from "../../utils/helpers/helpers";
import { GOOGLE_API_KEY } from "../../utils/constants/common";
import Header from "../../components/Navbar/Header";
import Footer from "../../components/Navbar/Footer";
import Navbar from "../../components/Navbar";
import { Link } from "react-router-dom";

const GoogleMapWithMarkers = () => {
  const [clientCoordinates, setClientCoordinates] = useState({
    // lat: -34.397,
    // lng: 150.644,
lat: 26.8862,
lng: 75.8335,

  });
  const [centerTitle, setCenterTitle] = useState(
    // "Laungrygo Office's Location "
    "Dotsquares Office "
  );
  const apiKey = GOOGLE_API_KEY;
  const mapRef = useRef(null);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const map = useRef(null); // Reference to the Google Map instance

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const authToken = getLocalStorageData("authorizationToken");
      if (!authToken) {
        navigate("/");
        return;
      }
      const response = await post("/Driver/GetDriversLocation", {});
      console.log("get driver location response....", response.data);
      if (response.data.data) {
        const transformedData = response.data.data.map((item) => ({
          id: item.driverId,
          name: item.driverName,
          location: { lat: item.latitude, lng: item.longitude },
          title: `${item.driverName}'s Location`,
        }));
        setUsers(transformedData);
      }
    } catch (error) {
      console.error("Error fetching driver locations:", error);
    }
  };

  useEffect(() => {
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // const initGoogleMap = () => {
    //   if (apiKey && users.length > 0 && !map.current) {
    //     const googleMapScript = document.createElement("script");
    //     googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    //     window.document.body.appendChild(googleMapScript);
    //     googleMapScript.addEventListener("load", () => {
    //       // const centerLocation = users.length > 0 ? users[0].location : { lat: 0, lng: 0 };
    //     const centerLocation = clientCoordinates  // client location
    //         map.current = new window.google.maps.Map(mapRef.current, {
    //         center: centerLocation,
    //         zoom: 11,
    //       });

    //        // Add marker for the center location with the specified title
    //        if (clientCoordinates) {
    //         new window.google.maps.Marker({
    //           position: clientCoordinates,
    //           map: map,
    //           title: centerTitle,
    //         });
    //       }

    //       // Add markers for users
    //       users.forEach((user) => {
    //         if (user.location) {
    //           // Check if user has location data
    //           new window.google.maps.Marker({
    //             position: user.location,
    //             map: map.current,
    //             title: user.title,
    //           });
    //         }
    //       });
    //     });
    //   }
    // };
    const initGoogleMap = () => {
      if (apiKey && !map.current) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        window.document.body.appendChild(googleMapScript);
        googleMapScript.addEventListener("load", () => {
          try {
            let centerLocation;
    
            if (users.length > 0 && users[0].location) {
              // Check if user has location data
              centerLocation = users[0].location;
            } else {
              // Default to Dotsquares office location
              centerLocation = { lat: 26.8862, lng: 75.8335 };
            }
    
            map.current = new window.google.maps.Map(mapRef.current, {
              center: centerLocation,
              zoom: 11,
            });
    
            // Add marker for the center location with the specified title
            new window.google.maps.Marker({
              position: centerLocation,
              map: map.current,
              title: centerTitle,
            });
    
            // Add markers for users
            users.forEach((user) => {
              if (user.location) {
                // Check if user has location data
                new window.google.maps.Marker({
                  position: user.location,
                  map: map.current,
                  title: user.title,
                });
              }
            });
          } catch (error) {
            console.error("Error initializing Google Map:", error);
          }
        });
      }
    };
    
    

    initGoogleMap();
  }, [apiKey, users]);

  useEffect(() => {
    if (map?.current && users?.length > 0) {
      // Clear existing markers
      map?.current?.data.forEach((marker) => {
        marker?.setMap(null);
      });

      // Add markers for users
      users?.forEach((user) => {
        new window.google.maps.Marker({
          position: user?.location,
          map: map?.current,
          title: user?.title,
        });
      });
    }
  }, [users]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <Header />
      
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
            <div className="page-header">
            <div class="lefth d-flex align-items-center justify-content-center flex-wrap">
            <h1 class="page-title me-3">Driver(s)</h1>

            <div class="headertabs ms-auto me-auto">


<Link
  to="/manage-drivers"
  // className="active"
  onClick={() => {
  
  }}
>
  All Drivers
</Link>
<Link
  to="/last-location"
  className="active"
  onClick={() => {
  
  }}
>
  Last known location
</Link>

</div>
</div><button onClick={handleRefresh} className="btn btn-default btn-sm">Refresh</button></div>
            <div className="page-content">
            <div className="locationDiv">
          <div style={{ height: "100%", width: "100%" }} ref={mapRef}>
            Loading map...
          </div>
        </div>
            </div>
            </div>
          </div>
          <Footer />
        </div>
        
      </div>
    </>
  );
};

export default GoogleMapWithMarkers;
